import styled from 'styled-components';

const device = {
  mobile: `(min-width: 310px) and (max-width: 480px)`,
  tablet: `(min-width: 481px) and (max-width: 768px)`,
  laptop: `(min-width: 769px) and (max-width: 1024px)`,
};

export const ProductsContainer = styled.div`
  min-height: 100vh;
  padding: 1rem calc((50vw - 1000px) / 3);
  background: linear-gradient(to right, #536976, #292e49);
`;

export const ProductWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 2rem;
  justify-items: center;
  margin: 0 auto;

  @media ${device.tablet} {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1rem;
  }
  @media ${device.mobile} {
    grid-template-columns: repeat(2, 2fr);
    grid-gap: 0.5rem;
  }
`;

export const ProductCard = styled.div`
  margin: 1.5rem;
  line-height: 2;
  width: 350px;
  background: #1a1a1a;
  box-shadow: 8px 8px 8px rgba(0, 0, 0, 0.2);
  transition: 0.3s ease;

  &:hover {
    transform: scale(1.03);
  }

  @media ${device.tablet} {
    width: 150px;
  }

  @media ${device.mobile} {
    width: 120px;
  }
`;

export const ProductImg = styled.img`
  height: 300px;
  min-width: 349px;
  max-width: 100%;
  object-fit: cover;
  border-radius: 8px 8px 0 0;

  @media ${device.tablet} {
    height: 100px;
    min-width: 150px;
  }

  @media ${device.mobile} {
    height: 120px;
    min-width: 120px;
  }
`;

export const ProductsHeading = styled.h1`
  font-size: clamp(2rem, 2.5vw, 3rem);
  text-align: center;
  margin-bottom: 1rem;
  color: black;
`;

export const ProductTitle = styled.h2`
  font-weight: 400;
  font-size: 1.5rem;
  color: #fff;
  margin-bottom: 1rem;

  @media ${device.mobile} {
    font-size: 0.8rem;
  }

  @media ${device.tablet} {
    font-size: 1rem;
  }

`;

export const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  text-align: center;
`;

export const ProductDesc = styled.p`
  margin-bottom: 1rem;
  color: #fff;

  @media ${device.mobile} {
    font-size: 0.8rem;
  }

  @media ${device.tablet} {
    font-size: 1rem;
  }
`;

export const ProductPrice = styled.p`
  margin-bottom: 1rem;
  font-size: 2rem;
  color: #ffc500;
`;

export const ProductButton = styled.button`
  font-size: 1rem;
  padding: 1rem 4rem;
  border: none;
  background: #e31837;
  color: #fff;
  transition: 0.2s ease-out;
  cursor: pointer;
  border-radius: 4px;

  &:hover {
    background: #ffc500;
    transition: 0.2s ease-out;
    color: #000;
  }

  @media ${device.tablet} {
    padding: 0.8rem 3.2rem;
    font-size: 0.9rem;
  }

  @media ${device.mobile} {
    padding: 0.6rem 2rem;
    font-size: 0.6rem;
  }
`;
